(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("classnames"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "classnames"], factory);
	else if(typeof exports === 'object')
		exports["z-shop-ui.production"] = factory(require("react"), require("classnames"));
	else
		root["z-shop-ui.production"] = factory(root["react"], root["classnames"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://mosaic01.ztat.net/base-assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: external "react"
var external__react_ = __webpack_require__(0);
var external__react__default = /*#__PURE__*/__webpack_require__.n(external__react_);

// EXTERNAL MODULE: external "classnames"
var external__classnames_ = __webpack_require__(1);
var external__classnames__default = /*#__PURE__*/__webpack_require__.n(external__classnames_);

// EXTERNAL MODULE: ./components/button/src/button.scss
var src_button = __webpack_require__(3);
var button_default = /*#__PURE__*/__webpack_require__.n(src_button);

// CONCATENATED MODULE: ./lib/copy-props.js
function copyDataProps(source, target) {
    Object.keys(source).forEach(function (key) {
        if (key.indexOf('data-') === 0) {
            target[key] = source[key];
        }
    });

    return target;
}
// CONCATENATED MODULE: ./lib/browser-check.js
// Check whether running in browser or server (useful when considering server-side rendering)
var isBrowser = function isBrowser() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
};

// Check whether device is touch-enabled (useful when considering server-side rendering)
var isTouchDevice = function isTouchDevice() {
    if (!isBrowser()) {
        return false;
    }

    return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
};

var isSafari = function isSafari() {
    if (!isBrowser()) {
        return false;
    }

    return !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
};

var isIOS = function isIOS() {
    if (!isBrowser()) {
        return false;
    }

    return (/iPad|iPhone|iPod/.test(navigator.userAgent)
    );
};


// CONCATENATED MODULE: ./components/button/src/button.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var BASE_CLASS = (function(sel) {
    // eslint-disable-next-line
    return 'z-' + String(sel);
})('button');
var touchDevice = isTouchDevice();

var button_Button = function Button(props) {
    var _classNames;

    var className = props.className,
        children = props.children,
        priority = props.priority,
        type = props.type,
        inverted = props.inverted,
        inline = props.inline,
        disableAnimation = props.disableAnimation,
        href = props.href,
        name = props.name,
        onClick = props.onClick,
        onTap = props.onTap,
        light = props.light,
        nextGen = props.nextGen,
        shadow = props.shadow,
        onTouchStart = props.onTouchStart;


    var componentClassNames = external__classnames__default()(BASE_CLASS, className, BASE_CLASS + '--' + priority + ' ' + BASE_CLASS + '--' + type, (_classNames = {}, _defineProperty(_classNames, BASE_CLASS + '--inline', inline), _defineProperty(_classNames, BASE_CLASS + '--inverted', inverted), _defineProperty(_classNames, BASE_CLASS + '--no-animation', disableAnimation || touchDevice), _defineProperty(_classNames, BASE_CLASS + '--touch', touchDevice), _defineProperty(_classNames, BASE_CLASS + '--light', light && priority === 'tertiary'), _defineProperty(_classNames, BASE_CLASS + '--next-gen', nextGen), _defineProperty(_classNames, BASE_CLASS + '--shadow', nextGen && shadow), _classNames));

    var filteredProps = {
        className: componentClassNames,
        onClick: onTap || onClick,
        onTouchStart: onTouchStart
    };

    // keep any data attributes passed as props
    copyDataProps(props, filteredProps);

    var Tag = 'button';

    if (type === 'link') {
        Tag = 'a';
        filteredProps.href = href;
    } else {
        filteredProps.name = name;
        filteredProps.type = type;
    }

    return external__react__default.a.createElement(
        Tag,
        filteredProps,
        external__react__default.a.createElement(
            'div',
            { className: BASE_CLASS + '__content' },
            children
        )
    );
};

button_Button.defaultProps = {
    className: '',
    inline: false,
    inverted: false,
    priority: 'secondary',
    type: 'button',
    disableAnimation: false,
    href: '',
    name: '',
    nextGen: false,
    shadow: false,
    onClick: function onClick() {},
    onTouchStart: function onTouchStart() {}
};

/* harmony default export */ var button_src_button = (button_Button);
// EXTERNAL MODULE: ./components/lipstick-grid/src/grid.scss
var grid = __webpack_require__(4);
var grid_default = /*#__PURE__*/__webpack_require__.n(grid);

// CONCATENATED MODULE: ./lib/props-to-attributes.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function writeFlattenedProp(target, name, value) {
    if (value === undefined || value === null || value === false) {
        return;
    }

    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        Object.keys(value).forEach(function (key) {
            writeFlattenedProp(target, name + '-' + key, value[key]);
        });
    } else if (value === true) {
        target[name] = '';
    } else {
        target[name] = String(value);
    }
}
// CONCATENATED MODULE: ./components/lipstick-grid/src/grid-item.js




function GridItem(props) {
    var attributes = {
        children: props.children
    };

    writeFlattenedProp(attributes, 'span', props.span);
    writeFlattenedProp(attributes, 'offset', props.offset);
    writeFlattenedProp(attributes, 'order', props.order);

    writeFlattenedProp(attributes, 'class', props.className);

    return external__react__default.a.createElement('z-grid-item', attributes);
}

GridItem.defaultProps = {
    span: null,
    offset: null,
    order: null
};
// CONCATENATED MODULE: ./components/lipstick-grid/src/grid-base.js





function GridBase(props) {
    var attributes = {
        children: props.children
    };

    writeFlattenedProp(attributes, 'spacing', props.spacing);
    writeFlattenedProp(attributes, 'inline', props.inline);
    writeFlattenedProp(attributes, 'span', props.span);
    writeFlattenedProp(attributes, 'valign', props.valign);
    writeFlattenedProp(attributes, 'align', props.align);

    writeFlattenedProp(attributes, 'class', props.className);
    writeFlattenedProp(attributes, 'nowrap', !props.wrap);

    return external__react__default.a.createElement('z-grid', attributes);
}

GridBase.defaultProps = {
    inline: false,
    spacing: 'gutter',
    wrap: true
};
// CONCATENATED MODULE: ./components/lipstick-grid/src/lipstick-grid.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









if (typeof navigator !== 'undefined' && /.*?Android\s+[24]\.[0123]/.test(navigator.userAgent)) {
    document.documentElement.className += ' z-grid-android';
}

var lipstick_grid_Grid = function (_React$Component) {
    _inherits(Grid, _React$Component);

    function Grid() {
        _classCallCheck(this, Grid);

        return _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).apply(this, arguments));
    }

    _createClass(Grid, [{
        key: 'render',
        value: function render() {
            return external__react__default.a.createElement(
                GridBase,
                {
                    valign: this.props.valign,
                    align: this.props.align,
                    className: this.props.className
                },
                this.props.children
            );
        }
    }]);

    return Grid;
}(external__react__default.a.Component);

/* harmony default export */ var lipstick_grid = (lipstick_grid_Grid);


lipstick_grid_Grid.Item = GridItem;
// CONCATENATED MODULE: ./dist/icon-meta.js
/* harmony default export */ var icon_meta = ({
    'add-to-wishlist': {
        'viewBox': '0 0 18 16',
        'width': '18',
        'height': '16'
    },
    'arrow-down-tiny': {
        'viewBox': '0 0 10 10',
        'width': '10',
        'height': '10'
    },
    'arrow-up-tiny': {
        'viewBox': '0 0 10 10',
        'width': '10',
        'height': '10'
    },
    'bag-bold': {
        'viewBox': '0 0 30 30',
        'width': '30',
        'height': '30'
    },
    'bag-bolder': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'bag-semi-bold': {
        'viewBox': '0 0 26 26',
        'width': '26',
        'height': '26'
    },
    'bag-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'bag-thin': {
        'viewBox': '0 0 26 26',
        'width': '26',
        'height': '26'
    },
    'bag': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'breadcrumb-arrow-black-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'breadcrumb-arrow-grey-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'check-tiny': {
        'viewBox': '0 0 12 10',
        'width': '12',
        'height': '10'
    },
    'checkmark-filterselected-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'checkmark-following-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'checkmark-path': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'checkmark-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'chevron-left-inactive-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'chevron-left-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'chevron-right-inactive-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'chevron-right-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'close-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'close-white-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'close': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'customerservice-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'delivery-express': {
        'viewBox': '0 0 24 16',
        'width': '24',
        'height': '16'
    },
    'delivery-standard': {
        'viewBox': '0 0 16 16',
        'width': '16',
        'height': '16'
    },
    'dropdown-collapse-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'dropdown-expand-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'edit': {
        'viewBox': '0 0 16 16',
        'width': '16',
        'height': '16'
    },
    'email': {
        'viewBox': '0 0 20 16',
        'width': '20',
        'height': '16'
    },
    'error-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'follow-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'go-back-tiny': {
        'viewBox': '0 0 12 10',
        'width': '12',
        'height': '10'
    },
    'go-back-white': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'go-back': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'help-bold': {
        'viewBox': '0 0 30 30',
        'width': '30',
        'height': '30'
    },
    'help-bolder': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'help-semi-bold': {
        'viewBox': '0 0 26 26',
        'width': '26',
        'height': '26'
    },
    'help-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'help-thin': {
        'viewBox': '0 0 26 26',
        'width': '26',
        'height': '26'
    },
    'help': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'hotline': {
        'viewBox': '0 0 16 16',
        'width': '16',
        'height': '16'
    },
    'ic_error_lrg': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'ic_error_sml': {
        'viewBox': '0 0 16 16',
        'width': '16',
        'height': '16'
    },
    'ic_generic_lrg': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'ic_generic_sml': {
        'viewBox': '0 0 16 16',
        'width': '16',
        'height': '16'
    },
    'ic_info_lrg': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'ic_info_sml': {
        'viewBox': '0 0 16 16',
        'width': '16',
        'height': '16'
    },
    'ic_success_lrg': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'ic_success_sml': {
        'viewBox': '0 0 16 16',
        'width': '16',
        'height': '16'
    },
    'in-wishlist': {
        'viewBox': '0 0 18 16',
        'width': '18',
        'height': '16'
    },
    'leftarrow-white': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'leftarrow': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'media-fullscreen': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'media-pause-large': {
        'viewBox': '0 0 80 80',
        'width': '80',
        'height': '80'
    },
    'media-pause-small': {
        'viewBox': '0 0 40 40',
        'width': '40',
        'height': '40'
    },
    'media-play-large': {
        'viewBox': '0 0 80 80',
        'width': '80',
        'height': '80'
    },
    'media-play-small': {
        'viewBox': '0 0 40 40',
        'width': '40',
        'height': '40'
    },
    'media-sound-off': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'media-sound-on': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'menu-semi-bold': {
        'viewBox': '0 0 26 26',
        'width': '26',
        'height': '26'
    },
    'menu-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'menu': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'more-info': {
        'viewBox': '0 0 16 16',
        'width': '16',
        'height': '16'
    },
    'notification-error': {
        'viewBox': '0 0 16 16',
        'width': '16',
        'height': '16',
        'name': 'notification-error__attention'
    },
    'attention': {
        'viewBox': '0 0 16 16',
        'width': '16',
        'height': '16',
        'name': 'notification-error__attention'
    },
    'notification-info': {
        'viewBox': '0 0 16 16',
        'width': '16',
        'height': '16',
        'name': 'notification-info__info'
    },
    'info': {
        'viewBox': '0 0 16 16',
        'width': '16',
        'height': '16',
        'name': 'notification-info__info'
    },
    'notification-success': {
        'viewBox': '0 0 16 16',
        'width': '16',
        'height': '16'
    },
    'notifyme-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'pagination-chevron-left-active': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'pagination-chevron-left-inactive': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'pagination-chevron-right-active': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'pagination-chevron-right-inactive': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'profile-bold': {
        'viewBox': '0 0 30 30',
        'width': '30',
        'height': '30'
    },
    'profile-bolder': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'profile-semi-bold': {
        'viewBox': '0 0 26 26',
        'width': '26',
        'height': '26'
    },
    'profile-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'profile-thin': {
        'viewBox': '0 0 26 26',
        'width': '26',
        'height': '26'
    },
    'profile': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'remove-from-wishlist': {
        'viewBox': '0 0 18 16',
        'width': '18',
        'height': '16'
    },
    'remove-tiny': {
        'viewBox': '0 0 10 10',
        'width': '10',
        'height': '10',
        'name': 'remove-tiny__close-tiny'
    },
    'close-tiny': {
        'viewBox': '0 0 10 10',
        'width': '10',
        'height': '10',
        'name': 'remove-tiny__close-tiny'
    },
    'removefilter-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'returns-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'returns': {
        'viewBox': '0 0 20 16',
        'width': '20',
        'height': '16'
    },
    'rightarrow-white': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'rightarrow': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'search-semi-bold': {
        'viewBox': '0 0 26 26',
        'width': '26',
        'height': '26'
    },
    'search-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'search': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'shipping-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'slider-arrow-left': {
        'viewBox': '0 0 8 16',
        'width': '8',
        'height': '16'
    },
    'slider-arrow-right': {
        'viewBox': '0 0 8 16',
        'width': '8',
        'height': '16'
    },
    'spinner': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'unfollow-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'wishlist-bold': {
        'viewBox': '0 0 30 30',
        'width': '30',
        'height': '30'
    },
    'wishlist-bolder': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'wishlist-filled-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'wishlist-filled': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    },
    'wishlist-semi-bold': {
        'viewBox': '0 0 26 26',
        'width': '26',
        'height': '26'
    },
    'wishlist-small': {
        'viewBox': '0 0 24 24',
        'width': '24',
        'height': '24'
    },
    'wishlist-thin': {
        'viewBox': '0 0 26 26',
        'width': '26',
        'height': '26'
    },
    'wishlist': {
        'viewBox': '0 0 36 36',
        'width': '36',
        'height': '36'
    }
});
// EXTERNAL MODULE: ./components/icon/src/icon.scss
var icon = __webpack_require__(5);
var icon_default = /*#__PURE__*/__webpack_require__.n(icon);

// CONCATENATED MODULE: ./components/icon/src/icon.js





var icon_BASE_CLASS = (function(sel) {
    // eslint-disable-next-line
    return 'z-' + String(sel);
})('icon');
var names = Object.keys(icon_meta);
names.sort();

var icon_Icon = function Icon(_ref) {
    var className = _ref.className,
        name = _ref.name,
        iconColor = _ref.iconColor,
        SvgRef = _ref.svgRef;

    var meta = icon_meta[name];
    if (!meta) {
        return external__react__default.a.createElement('span', { className: icon_BASE_CLASS });
    }

    var suffix = '-tiny';
    var svgName = meta.name || name;
    var xlink = '#icon_svg-' + svgName;
    var size = svgName.slice(-suffix.length) === suffix ? 'tiny' : 'small';
    var clName = icon_BASE_CLASS + ' ' + icon_BASE_CLASS + '-' + name + ' ' + icon_BASE_CLASS + '-' + size + ' ' + icon_BASE_CLASS + '-' + iconColor + ' ' + className;

    return external__react__default.a.createElement(
        'span',
        { className: clName },
        SvgRef ? external__react__default.a.createElement(SvgRef, {
            width: meta.width,
            height: meta.height,
            viewBox: meta.viewBox,
            className: icon_BASE_CLASS + '_svg'
        }) : external__react__default.a.createElement(
            'svg',
            {
                width: meta.width,
                height: meta.height,
                viewBox: meta.viewBox,
                className: icon_BASE_CLASS + '_svg'
            },
            external__react__default.a.createElement('use', { xlinkHref: xlink })
        )
    );
};

icon_Icon.names = names;

icon_Icon.defaultProps = {
    size: 'small',
    className: '',
    iconColor: 'black',
    svg: null
};

/* harmony default export */ var src_icon = (icon_Icon);
// EXTERNAL MODULE: ./components/link/src/link.scss
var src_link = __webpack_require__(6);
var link_default = /*#__PURE__*/__webpack_require__.n(src_link);

// CONCATENATED MODULE: ./lib/callSafe.js
// Check typeof func and calls it if it's a function.
var callSafe = function callSafe(func) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var that = arguments[2];

    if (typeof func === 'function') {
        return func.apply(that, args);
    }

    return undefined;
};

/* harmony default export */ var lib_callSafe = (callSafe);
// CONCATENATED MODULE: ./components/link/src/link.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var link__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function link__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function link__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function link__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function link__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var link_BASE_CLASS = (function(sel) {
    // eslint-disable-next-line
    return 'z-' + String(sel);
})('link');

var link_Link = function (_Component) {
    link__inherits(Link, _Component);

    function Link(props) {
        link__classCallCheck(this, Link);

        var _this = link__possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    link__createClass(Link, [{
        key: 'handleClick',
        value: function handleClick(e) {
            lib_callSafe(this.props.onClick, [e]);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                className = _props.className,
                href = _props.href,
                title = _props.title,
                target = _props.target,
                children = _props.children,
                type = _props.type,
                lineAnimation = _props.lineAnimation,
                visitedState = _props.visitedState;


            var componentClassNames = external__classnames__default()(link_BASE_CLASS, className, link_BASE_CLASS + '-' + type, (_classNames = {}, link__defineProperty(_classNames, link_BASE_CLASS + '-underline', lineAnimation), link__defineProperty(_classNames, link_BASE_CLASS + '-visited', visitedState), _classNames));

            var rel = target === '_blank' ? 'noopener noreferrer' : '';

            var filteredProps = _extends({}, this.props);
            delete filteredProps.lineAnimation;
            delete filteredProps.visitedState;

            var Tag = 'a';
            if (!href) {
                Tag = 'span';
            }

            return external__react__default.a.createElement(
                Tag,
                _extends({}, filteredProps, {
                    className: componentClassNames,
                    title: title,
                    href: href,
                    target: target,
                    rel: rel,
                    role: 'link',
                    onClick: this.handleClick
                }),
                children
            );
        }
    }]);

    return Link;
}(external__react_["Component"]);

link_Link.defaultProps = {
    className: '',
    target: '',
    type: 'default',
    lineAnimation: false,
    visitedState: false
};

/* harmony default export */ var link_src_link = (link_Link);
// EXTERNAL MODULE: ./components/rich-button/src/rich-button.scss
var rich_button = __webpack_require__(7);
var rich_button_default = /*#__PURE__*/__webpack_require__.n(rich_button);

// CONCATENATED MODULE: ./components/rich-button/src/rich-button.js
function rich_button__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var rich_button_BASE_CLASS = (function(sel) {
    // eslint-disable-next-line
    return 'z-' + String(sel);
})('rich-button');
var rich_button_touchDevice = isTouchDevice();

var rich_button_RichButton = function RichButton(_ref) {
    var _classNames;

    var loadingState = _ref.loadingState,
        errorState = _ref.errorState,
        successState = _ref.successState,
        disableAnimation = _ref.disableAnimation,
        inverted = _ref.inverted,
        className = _ref.className,
        onClick = _ref.onClick,
        priority = _ref.priority,
        light = _ref.light,
        successMsg = _ref.successMsg,
        children = _ref.children,
        errorMsg = _ref.errorMsg,
        nextGen = _ref.nextGen,
        shadow = _ref.shadow,
        onTouchStart = _ref.onTouchStart;

    var componentClassNames = external__classnames__default()(rich_button_BASE_CLASS, className, rich_button_BASE_CLASS + '--' + priority, (_classNames = {}, rich_button__defineProperty(_classNames, rich_button_BASE_CLASS + '--state-change', loadingState || errorState || successState), rich_button__defineProperty(_classNames, rich_button_BASE_CLASS + '--loading-state', loadingState), rich_button__defineProperty(_classNames, rich_button_BASE_CLASS + '--success-state', successState), rich_button__defineProperty(_classNames, rich_button_BASE_CLASS + '--error-state', errorState), rich_button__defineProperty(_classNames, rich_button_BASE_CLASS + '--inverted', inverted), rich_button__defineProperty(_classNames, rich_button_BASE_CLASS + '--light', light && priority === 'tertiary'), rich_button__defineProperty(_classNames, rich_button_BASE_CLASS + '--no-animation', disableAnimation || rich_button_touchDevice), rich_button__defineProperty(_classNames, rich_button_BASE_CLASS + '--touch', rich_button_touchDevice), rich_button__defineProperty(_classNames, rich_button_BASE_CLASS + '--next-gen', nextGen), rich_button__defineProperty(_classNames, rich_button_BASE_CLASS + '--shadow', nextGen && shadow), _classNames));
    var BASE_CLASS_ITEM = rich_button_BASE_CLASS + '__item';

    return (
        // onTouchStart to disable the hover event on IOS devices otherwise
        // It will require double tap to fire the onClick event
        external__react__default.a.createElement(
            'button',
            { className: componentClassNames, onTouchStart: onTouchStart, onClick: onClick },
            external__react__default.a.createElement(
                'span',
                { className: BASE_CLASS_ITEM + ' ' + BASE_CLASS_ITEM + '--success' },
                external__react__default.a.createElement(src_icon, { name: 'checkmark-small', iconColor: 'white' }),
                successMsg
            ),
            external__react__default.a.createElement(
                'span',
                { className: BASE_CLASS_ITEM + ' ' + BASE_CLASS_ITEM + '--content' },
                children
            ),
            external__react__default.a.createElement(
                'span',
                { className: BASE_CLASS_ITEM + ' ' + BASE_CLASS_ITEM + '--error' },
                errorMsg
            ),
            external__react__default.a.createElement(
                'span',
                { className: BASE_CLASS_ITEM + ' ' + BASE_CLASS_ITEM + '--loading' },
                external__react__default.a.createElement(src_icon, { name: 'spinner', iconColor: 'white' })
            )
        )
    );
};

rich_button_RichButton.defaultProps = {
    className: '',
    loadingState: false,
    successState: false,
    errorState: false,
    priority: 'primary',
    errorMsg: 'Error - Try Again',
    successMsg: 'Added to bag',
    inverted: false,
    onClick: function onClick() {},
    onTouchStart: function onTouchStart() {}
};

/* harmony default export */ var src_rich_button = (rich_button_RichButton);
// EXTERNAL MODULE: ./components/text/src/text.scss
var src_text = __webpack_require__(8);
var text_default = /*#__PURE__*/__webpack_require__.n(src_text);

// CONCATENATED MODULE: ./components/text/src/text.js
function text__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var text_BASE_CLASS = (function(sel) {
    // eslint-disable-next-line
    return 'z-' + String(sel);
})('text');

var text_Text = function Text(_ref) {
    var _classNames;

    var type = _ref.type,
        block = _ref.block,
        className = _ref.className,
        children = _ref.children,
        textColor = _ref.textColor,
        Component = _ref.component,
        textTransform = _ref.textTransform;

    var componentClassNames = external__classnames__default()(text_BASE_CLASS, className, (_classNames = {}, text__defineProperty(_classNames, text_BASE_CLASS + '-block', block), text__defineProperty(_classNames, text_BASE_CLASS + '-' + type, type), text__defineProperty(_classNames, text_BASE_CLASS + '-' + textColor, textColor), text__defineProperty(_classNames, text_BASE_CLASS + '--uppercase', textTransform === 'uppercase'), text__defineProperty(_classNames, text_BASE_CLASS + '--capitalize', textTransform === 'capitalize'), text__defineProperty(_classNames, text_BASE_CLASS + '--normal', textTransform === 'none'), _classNames));

    return external__react__default.a.createElement(
        Component,
        { className: componentClassNames },
        children
    );
};

text_Text.defaultProps = {
    className: '',
    type: 'default',
    component: 'span',
    block: false,
    textColor: 'black',
    textTransform: 'default'
};

/* harmony default export */ var text_src_text = (text_Text);
// CONCATENATED MODULE: ./index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UI; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Button", function() { return button_src_button; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Grid", function() { return lipstick_grid; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Icon", function() { return src_icon; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Link", function() { return link_src_link; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "RichButton", function() { return src_rich_button; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Text", function() { return text_src_text; });







var UI = {
    Button: button_src_button,
    Grid: lipstick_grid,
    Icon: src_icon,
    Link: link_src_link,
    RichButton: src_rich_button,
    Text: text_src_text
};



/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);
});
//# sourceMappingURL=z-shop-ui.production.js.map